import { useAppStore } from '@/state'
import { Progress } from '@/components/ui/progress'

export const ViewWorkerStatus = () => {
  const viewUploadsInProgress = useAppStore(
    (state) => state.viewUploadsInProgress,
  )
  const viewUploadsCompleted = useAppStore(
    (state) => state.viewUploadsCompleted,
  )
  const isViewWorkerProcessing = useAppStore(
    (state) => state.isViewWorkerProcessing,
  )

  const totalUploads =
    viewUploadsInProgress.length + viewUploadsCompleted.length
  const progress =
    totalUploads > 0 ? (viewUploadsCompleted.length / totalUploads) * 100 : 0

  return (
    <div className="fixed bottom-4 right-4 z-[60] w-80 bg-background border rounded-md shadow-lg p-4">
      <div className="space-y-3">
        <h3 className="text-sm font-semibold">View Worker Status</h3>
        <div className="flex items-center space-x-2">
          <div
            className={`w-2 h-2 rounded-full ${
              isViewWorkerProcessing ? 'bg-green-500' : 'bg-red-500'
            }`}
          />
          <span className="text-xs">
            {isViewWorkerProcessing ? 'Processing' : 'Idle'}
          </span>
        </div>
        <div className="space-y-1">
          <div className="flex justify-between text-xs">
            <span>Progress</span>
            <span>
              {viewUploadsCompleted.length}/{totalUploads}
            </span>
          </div>
          <Progress value={progress} className="h-1" />
        </div>
        <div className="text-xs text-muted-foreground">
          {viewUploadsInProgress.length} views remaining
        </div>
      </div>
    </div>
  )
}
